import { render, staticRenderFns } from "./featureDetail.vue?vue&type=template&id=860ebe06&scoped=true&"
import script from "./featureDetail.vue?vue&type=script&lang=js&"
export * from "./featureDetail.vue?vue&type=script&lang=js&"
import style0 from "./featureDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./featureDetail.vue?vue&type=style&index=1&id=860ebe06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860ebe06",
  null
  
)

/* custom blocks */
import block0 from "./featureDetail.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports